import {ArrayUtils} from "./ArrayUtils";

export interface StateMatrixCoordinate {
    column: number;
    row: number;
}

export class StateMatrix<T> {
    public readonly columns: number;
    public readonly rows: number;

    constructor(initMatrix?: T[][]) {
        this._matrix = initMatrix ? ArrayUtils.cloneMatrix(initMatrix) : [];
    }

    private _matrix: T[][];

    get matrix(): T[][] {
        return this._matrix;
    }

    set matrix(value: T[][]) {
        this._matrix = value;
    }
}